import { MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import styled from 'styled-components';
import { ZoomButtonWrapper } from '../../productConfig/productConfigStyles';

const ImgContainer = styled.div`
  flex: 1 0 calc(25% - 24px); // 25% for 4-across grid minus gutter
  max-width: calc(25% - 24px); // Ensure 4-across grid always
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    flex: 0 1 calc(50% - 14px);
    max-width: calc(50% - 14px);
  }

  img {
    max-width: 100%;
    height: auto;
    background-color: white;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.1);
    pointer-events: none;
    -webkit-user-drag: none;
    user-select: none;
    object-fit: cover;
  }
`;

const Name = styled.div`
  text-align: center;
  margin-top: 10px;
`;

const PoseItem = ({ onClick, name, ...rest }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const handleZoomChange = useCallback((shouldZoom) => {
    setIsZoomed(shouldZoom);
  }, []);

  const handleZoomClick = (e) => {
    e.stopPropagation();
    setIsZoomed((zoomed) => !zoomed);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  return (
    <ImgContainer onContextMenu={(event) => event.preventDefault()}>
      <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
        <div
          role="button"
          onClick={onClick}
          tabIndex="0"
          onKeyDown={handleKeyDown}
        >
          <img
            {...rest}
            alt={rest.alt || ''}
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        <ZoomButtonWrapper onClick={handleZoomClick}>
          <MagnifyingGlassPlusIcon />
        </ZoomButtonWrapper>
        {name && <Name>{name}</Name>}
      </ControlledZoom>
    </ImgContainer>
  );
};

PoseItem.propTypes = {
  onClick: PropTypes.func,
  name: PropTypes.string,
};

PoseItem.defaultProps = {
  onClick: null,
  name: '',
};

export default PoseItem;
